const jsonSchema = [
  {
    name: 'date',
    label: 'Date',
    type: 'date',
    required: true,
    showInList: true,
  },
  {
    name: 'class',
    label: 'Class',
    type: 'multiselect',
    showInList: true,
  },

  {
    name: 'status',
    label: 'Status',
    type: 'multiselect',
    showInList: true,

  }

  // Add more fields as needed
];
export default jsonSchema;
